// FormData
export const FORM_DATA_AD_EXPIRY_DATE =
  'DISPATCHER_ID_FORM_DATA_AD_EXPIRY_DATE';

// Session
export const SESSION_IS_JOB_POSTED = 'DISPATCHER_ID_IS_JOB_POSTED';
export const SESSION_PAGE_ID = 'DISPATCHER_ID_PAGE_ID';

// Tealium
export const TEALIUM_AD_TYPE = 'DISPATCHER_ID_TEALIUM_AD_TYPE';
export const TEALIUM_CAJA_ABOUT_BUSINESS_CHARACTER_COUNT =
  'DISPATCHER_ID_TEALIUM_CAJA_ABOUT_BUSINESS_CHARACTER_COUNT';
export const TEALIUM_CAJA_CREATE_FLOW_TYPE =
  'DISPATCHER_ID_TEALIUM_CAJA_CREATE_FLOW_TYPE';
export const TEALIUM_CAJA_PAY_TYPE = 'DISPATCHER_ID_TEALIUM_CAJA_PAY_TYPE';
export const TEALIUM_FINAL_JOB_SUMMARY_CHARACTER_COUNT =
  'DISPATCHER_ID_TEALIUM_FINAL_JOB_SUMMARY_CHARACTER_COUNT';
export const TEALIUM_HAS_BRAND_ASSETS =
  'DISPATCHER_ID_TEALIUM_HAS_BRAND_ASSETS';
export const TEALIUM_PAGE = 'TEALIUM_PAGE';
export const TEALIUM_PAYMENT_METHOD = 'DISPATCHER_ID_TEALIUM_PAYMENT_METHOD';
export const TEALIUM_ROLE_TITLE = 'DISPATCHER_ID_TEALIUM_ROLE_TITLE';
export const TEALIUM_SEEK_LISTING_ID = 'DISPATCHER_ID_TEALIUM_SEEK_LISTING_ID';
export const TEALIUM_TEXT_INPUT_LIST_UPDATE =
  'DISPATCHER_ID_TEALIUM_TEXT_INPUT_LIST_UPDATE';

// Utils
export const UTILS_ADD_FORM_DATA = 'DISPATCHER_ID_UTILS_ADD_FORM_DATA';
export const UTILS_DEV_RESET_ALL_DATA =
  'DISPATCHER_ID_UTILS_DEV_RESET_ALL_DATA';
export const UTILS_RESET_PERSISTENT_DATA =
  'DISPATCHER_ID_UTILS_RESET_PERSISTENT_DATA';
